import { Plugin1cParamsDto, type Plugin1cParamsInterface } from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-params.dto';
import { Plugin1cFormDto, type Plugin1cFormInterface } from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';

/** Extended frontend version of the 1C ERP plugin description create and update APIs request body - DTO signature */
export interface Plugin1cFrontendFormInterface extends Plugin1cParamsInterface, Plugin1cFormInterface {}

/** Extended frontend version of the 1C ERP plugin description create and update APIs request body - DTO schema */
export const Plugin1cFrontendFormDto = SerdeDtoClass.union<Plugin1cFrontendFormInterface>(IntergrationDtoKeyEnum.PLUGIN_1C_FRONTEND_FORM_DTO, [
  Plugin1cParamsDto,
  Plugin1cFormDto,
]);
